import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";
import { ContextMenuOverlay } from "commonComponents/utilities/ContextMenuOverlay/ContextMenuOverlay";

const MenuNoActions = ({ ...antProps }) => {
    return (
        <ContextMenuOverlay>
            <BTMenu testid="noActionsMenu" {...antProps}>
                <BTMenu.Item disabled testid="noActionsAvailable" key="noActionsAvailable">
                    No actions available
                </BTMenu.Item>
            </BTMenu>
        </ContextMenuOverlay>
    );
};

export default MenuNoActions;
